// removed by extract-text-webpack-plugin
module.exports = {"container":"_3z4gN9pYEpC8R8D3FJl9VF","buttons":"_2MTAsODyog5w9OU7tl4lwh"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/Save/styles.css
// module id = 3250
// module chunks = 0